﻿

$(function () {

    var Acceptcookies = function () {

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        var showCookieDiv = function () {
            var usercookie = $(".cookie-information");
            if (!getCookie("_acceptCookies"))
                usercookie.removeClass("is-hidden");
        };

        $(".js-accept-cookies").on("click", function () {
            setCookie("_acceptCookies", "yes", 365);
            var usercookie = $(".cookie-information");
            usercookie.fadeOut("200", function () {
                $(this).addClass("is-hidden");
            });
        });

        return {
            init: function () {
                showCookieDiv();
                return false;
            }
        };
    };

    $(document).ready(function () {
        var acceptcookies = new Acceptcookies();
        acceptcookies.init();
    });

});